import { useSearch as useTanstackSearch } from '@tanstack/react-router';
export function useSearch(options) {
    return useTanstackSearch(options);
}
